import React, {useEffect, useState} from "react";
import { useIntl } from 'react-intl';

// Components
import { Form, Pill } from 'Components';
import { Grid } from '@mui/material';
import Slider from 'Components/Slider';
import TriggerLandmark from "Modules/alerts/components/wizardAlert/common/components/TriggerLandmark";


export const Stop = (props) => {

    const { value, onChange, formRef, triggers, triggersRaw } = props
    const { messages } = useIntl()
    const [showErrorTrigger, setShowErrorTrigger] = useState(false)

    useEffect(() => {
        if (value.triggerDuration == undefined)
            onChange({
                ...value,
                triggerDuration: {
                    duration: 'Immediate',
                    value: 0,
                },
            })
    }, [value])

    return (
        <Form ref={formRef}
              onSubmit={() => {
                  if (value.trigger) {
                      let isValid = triggersRaw?.length > 0

                      if (!isValid) {
                          setShowErrorTrigger(true)
                      } else setShowErrorTrigger(false)
                      return isValid
                  }
              }}
        >
            {
                value.triggerDuration != undefined &&
                <Grid container justifyContent={'center'} direction={'column'} style={{ paddingTop: 10 }}>
                    <Grid item >
                        <div style={{ paddingBottom: 5 }}>
                            <label className="input-normal-label" >{messages['alertsNewAlert_triggersLabel']}</label>
                        </div>
                        <Grid container direction="row" alignItems={'center'} spacing={1} color="primary" aria-label="outlined primary button group">
                            <Grid item sm={3}>
                                <Pill
                                    textField={'name'}
                                    item={{ id: "Immediate", name: messages["alertsNewAlert_immediateLabel"] }}
                                    outlined={value.triggerDuration?.duration !== "Immediate"}
                                    onClick={(entity) => {
                                        onChange({ ...value, triggerDuration: { value: 0, duration: "Immediate" } })
                                    }}
                                    style={{ border: '0', margin: '2px 0', width: '100%' }}
                                    label="pill-label-text"
                                    colorField="default"
                                    colorSelection="005bf8"
                                />
                            </Grid>
                            <Grid item sm={3}>
                                <Pill
                                    textField={'name'}
                                    item={{ id: "Minutes", name: messages["alertsNewAlert_minutesLabel"] }}
                                    outlined={value.triggerDuration?.duration !== "Minutes"}
                                    onClick={(entity) => {
                                        onChange({ ...value, triggerDuration: { value: 1, duration: "Minutes" } })
                                    }}
                                    style={{ border: '0', margin: '2px 0', width: '100%' }}
                                    label="pill-label-text"
                                    colorField="default"
                                    colorSelection="005bf8"
                                />
                            </Grid>
                            <Grid item sm={3}>
                                <Pill
                                    textField={'name'}
                                    item={{ id: "Hours", name: messages["alertsNewAlert_hoursLabel"] }}
                                    outlined={value.triggerDuration?.duration !== "Hours"}
                                    onClick={(entity) => {
                                        onChange({ ...value, triggerDuration: { value: 1, duration: "Hours" } })
                                    }}
                                    style={{ border: '0', margin: '2px 0', width: '100%' }}
                                    label="pill-label-text"
                                    colorField="default"
                                    colorSelection="005bf8"
                                />
                            </Grid>
                            <Grid item sm={3}>
                                <Pill
                                    textField={'name'}
                                    item={{ id: "Days", name: messages["alertsNewAlert_daysLabel"] }}
                                    outlined={value.triggerDuration?.duration !== "Days"}
                                    onClick={(entity) => {
                                        onChange({ ...value, triggerDuration: { value: 1, duration: "Days" } })
                                    }}
                                    style={{ border: '0', margin: '2px 0', width: '100%' }}
                                    label="pill-label-text"
                                    colorField="default"
                                    colorSelection="005bf8"
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    {
                        value.triggerDuration?.duration && value.triggerDuration?.duration != "Immediate" &&
                        <div style={{ width: '100%', marginTop: 10, marginBottom: 30 }}>
                            {value.triggerDuration.duration == "Minutes" && messages['alertsNewAlert_minutes']}
                            {value.triggerDuration.duration == "Hours" && messages['alertsNewAlert_hours']}
                            {value.triggerDuration.duration == "Days" && messages['alertsNewAlert_days']}
                            <Slider
                                min={1}
                                max={
                                    value.triggerDuration.duration == "Minutes" && 59 ||
                                    value.triggerDuration.duration == "Hours" && 23 ||
                                    value.triggerDuration.duration == "Days" && 30
                                }
                                value={value.triggerDuration.value}
                                onChange={(event) => {
                                    onChange({
                                        ...value,
                                        triggerDuration: {
                                            value: event,
                                            duration: value.triggerDuration.duration,
                                        }
                                    })
                                }}
                                sliderOneColor={false}
                                showValue
                                valueLabelDisplay={'off'}
                            />
                        </div>
                    }
                    <Grid item style={{paddingTop:10}}>
                        <TriggerLandmark config={value} triggers={triggers} triggersRaw={triggersRaw} onChange={onChange} showErrorTrigger={showErrorTrigger}/>
                    </Grid>
                </Grid>
            }
        </Form>
    );
}
